import { render, staticRenderFns } from "./Programari.vue?vue&type=template&id=015aaed1"
import script from "./Programari.vue?vue&type=script&lang=js"
export * from "./Programari.vue?vue&type=script&lang=js"
import style0 from "./Programari.vue?vue&type=style&index=0&id=015aaed1&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports